module.exports = __webpack_public_path__ + "img/ControleQualidade.15a7f8a8.jpeg";